/* sb-dc-flagfit.js - 깃발 템플릿을 그 판에 맞게 다시 앉힌다. 2026-09-10 (v2).

   보고
   ----
   «Ruth 님이 Large 사이즈에 맞춰 작업했는데 디자인센터에서 보면 템플릿의
   위아래가 잘린다» / «S·M 을 고르면 픽셀이 자동으로 맞춰져야 한다».

   실측 (2026-09-10, flag-rect-rf-sale-l)
   ---------------------------------------
   파일은 2448 x 11232 px = 비율 0.2179. 판은 L 31x151.5(0.2046) · M 31x114(0.272)
   · S 31x90.5(0.3425) — **세 사이즈 어느 것과도 비율이 같지 않다.** 앱은 비율을
   지키면서 안쪽에 맞추므로(contain) 남는 쪽이 흰색으로 뜨고, 보는 사람은 그걸
   «잘렸다» 고 읽는다:  L 에서 위아래 4.63in 씩 · S 에서 좌우 5.64in 씩(판의 36%).

   근본 해법은 파일을 판 비율대로 다시 만드는 것이다(L 기준 2232 x 10908 px).
   **한 장으로 세 사이즈를 다 덧는 것은 불가능** — 1:7 그림을 1:2.9 판에 왜곡 없이
   못 넣는다. 이 파일은 그 사이에서 «비어 보이지는 않게» 만드는 보정이다.

   하는 일
   -------
   · 배경 레이어(그림 상자의 92% 이상을 덮는 것)는 판 전체로 펼친다.
   · 나머지는 한 배율로 안전영역(94%)에 들어가게 맞추고 가운데로 모은다. 비율 안 깨짐.
   · 이미 사방 6% 이내로 차 있으면 손대지 않는다(디자이너가 의도한 여백을 안 건드리려고).

   ⚠ v1 의 실패 — «텍스트가 막 왜갔다갔다» (2026-09-10 제보)
   ----------------------------------------------------------
   sb-dc-tplfix.js 는 시작 팝업이 닫힌 뒤 판을 다시 잡고 템플릿을 **몇 번이고 다시
   build** 한다. v1 은 20초 동안 0.7초마다 «안 채워졌으면 다시 맞춘다» 였고, 그 둘이
   서로 덮어쓰며 17번을 싸웠다(ran:17) — 화면에서 글자가 계속 움직였고, 끝나고 보니
   마지막엔 tplfix 쪽이 이기기까지 했다.
   그래서 v2 는 **기다렸다가 딱 한 번만 고친다**: 레이어 좌표와 판 크기가 2.4초
   동안 그대로일 때(= tplfix 가 손을 뜼 때) 한 번 적용하고 스스로 멈춘다.

   범위: 깃발 14 + 야드사인, ?tpl= 로 열었을 때만.
   진단: window.__dcFlagFit() */
(function () {
  'use strict';

  var HANDLES = [
    'feather-angled-flag-small', 'feather-angled-flag-medium', 'feather-angled-flag-large',
    'feather-angled-flag-x-large', 'feather-convex-flag-small', 'feather-convex-flag-medium',
    'feather-convex-flag-large', 'teardrop-flag-small', 'teardrop-flag-medium',
    'teardrop-flag-large', 'rectangle-flag-small', 'rectangle-flag-medium',
    'rectangle-flag-large', 'econo-feather-flag', 'yard-sign'
  ];

  var BG = 0.92;
  var SAFE = 0.94;
  var FULL = 0.06;
  var TICK = 400, SETTLE = 6, WINDOW_MS = 30000;
  var SCALARS = ['fontSizeIn', 'cornerRadiusIn', 'strokeWidthIn'];

  var info = { ran: 0, scale: 0, waited: 0, skipped: '', why: '' };
  window.__dcFlagFit = function () { return info; };

  function q(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; }
    catch (e) { return ''; }
  }

  var handle = q('product');
  if (HANDLES.indexOf(handle) < 0 || !q('tpl')) { info.why = 'not a flag template link'; return; }

  function box(layers) {
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    layers.forEach(function (l) {
      var x = +l.xIn || 0, y = +l.yIn || 0, w = +l.widthIn || 0, h = +l.heightIn || 0;
      if (x < x0) x0 = x;
      if (y < y0) y0 = y;
      if (x + w > x1) x1 = x + w;
      if (y + h > y1) y1 = y + h;
    });
    return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 };
  }

  function visible(sd) {
    if (!sd || !Array.isArray(sd.layers)) return [];
    return sd.layers.filter(function (l) { return l.visible !== false; });
  }

  function fitSide(api, side) {
    if(window.SBDC914?.host.handled(api[side])) return null;
    var layers = visible(api[side]);
    if (layers.length < 2) return false;
    var W = +api.spec.widthIn, H = +api.spec.heightIn;
    if (!(W > 0 && H > 0)) return false;

    var b = box(layers);
    if (!(b.w > 0 && b.h > 0 && isFinite(b.w) && isFinite(b.h))) return false;
    if (b.w >= W * (1 - FULL) && b.h >= H * (1 - FULL)) { info.skipped = 'already full'; return false; }

    var bgs = [], rest = [];
    layers.forEach(function (l) {
      if ((+l.widthIn) >= b.w * BG && (+l.heightIn) >= b.h * BG) bgs.push(l);
      else rest.push(l);
    });
    if (!rest.length) { rest = layers; bgs = []; }

    var c = box(rest);
    var s = Math.min(W * SAFE / c.w, H * SAFE / c.h);
    if (!(s > 0 && isFinite(s))) s = 1;
    var nx = (W - c.w * s) / 2, ny = (H - c.h * s) / 2;

    bgs.forEach(function (l) {
      api.updateLayer(l.id, { xIn: 0, yIn: 0, widthIn: W, heightIn: H });
    });
    rest.forEach(function (l) {
      var p = {
        xIn: nx + ((+l.xIn || 0) - c.x) * s,
        yIn: ny + ((+l.yIn || 0) - c.y) * s,
        widthIn: (+l.widthIn || 0) * s,
        heightIn: (+l.heightIn || 0) * s
      };
      for (var i = 0; i < SCALARS.length; i++) {
        if (typeof l[SCALARS[i]] === 'number') p[SCALARS[i]] = l[SCALARS[i]] * s;
      }
      api.updateLayer(l.id, p);
    });

    info.scale = Math.round(s * 1000) / 1000;
    return true;
  }

  function sigOf(api) {
    var L = (api.front && api.front.layers) || [];
    if (!L.length) return '';
    var s = api.spec.widthIn + 'x' + api.spec.heightIn;
    for (var i = 0; i < L.length; i++) {
      var l = L[i];
      s += '|' + l.id + ',' + (+l.xIn).toFixed(2) + ',' + (+l.yIn).toFixed(2)
         + ',' + (+l.widthIn).toFixed(2) + ',' + (+l.heightIn).toFixed(2);
    }
    return s;
  }

  var t0 = Date.now(), sig = '', same = 0, done = false;
  var t = setInterval(function () {
    if (done || Date.now() - t0 > WINDOW_MS) { clearInterval(t); return; }
    var api = window.__dcApi;
    if (!api || !api.spec || typeof api.updateLayer !== 'function') return;
    var s = sigOf(api);
    if (!s) { sig = ''; same = 0; return; }
    if (s !== sig) { sig = s; same = 0; return; }
    if (++same < SETTLE) { info.waited = same; return; }
    done = true;
    clearInterval(t);
    try {
      if (fitSide(api, 'front')) info.ran++;
      if (api.back && api.back.layers && api.back.layers.length > 1 && fitSide(api, 'back')) info.ran++;
    } catch (e) { info.why = 'error: ' + (e && e.message); }
  }, TICK);
})();
